import { render } from "./InvoiceFooter.vue?vue&type=template&id=7107152d&scoped=true"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7107152d"

export default script